export default "__VITE_ASSET__TaAllOjq__"